<template>
	<div class="p-0 text-grey-900">
		<div
			class="plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5"
		>
			<!-- Title and icon -->
			<div class="d-flex justify-content-between">
				<div class="d-flex align-items-center">
					<div class="me-2">
						<component
							:is="props.advantage.cardTitleIcon"
							:width="32"
							:height="32"
						></component>
					</div>
					<div class="title-2 text-grey-900">{{ props.advantage.title }}</div>
				</div>
				<!-- Close button -->
				<button class="ts-x-black ts-x-md" @click="handleClose"></button>
			</div>

			<BorderHorizontal />
			<!-- Image -->
			<div v-if="props.advantage.cardImage" class="mb-4">
				<img src="../restauration.png" alt="" class="w-100" />
			</div>
			<!-- Content -->
			<div v-html="props.advantage.cardContent"></div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

// Classes
import { ClubAdvantage } from "../classes/ClubAdvantage";

// Components
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

// Props
const props = defineProps<{
	advantage: ClubAdvantage;
}>();

const emit = defineEmits<{
	(e: "closePopup"): void;
}>();

// Methods
const handleClose = (): void => {
	emit("closePopup");
};
</script>

<style scoped>
.plus-info-inner-wrapper {
	min-height: 100vh;
}
</style>
